<template>
    <div>
        <div class="signup-header row border-bottom-light row justify-content-sm-center">
            <div class="col-sm-6">
                <h5 class="color-1">Your business</h5>
                <h2>Can you tell me a little bit about your business?</h2>
            </div>
        </div>

        <div class="row justify-content-sm-center">
            <div class="col-sm-6">
                <form class="shaded" @submit.stop.prevent="processFormFinish" novalidate>

                    <avatar-uploader placeholder="agent" :loadThisImage="accountSetup.imageLogoBase64" @uploadComplete="addUploadedAvatar"></avatar-uploader>

                    <div class="form-group mt-4" :class="{ error: $v.form.companyName.$error }">
                        <label class="full">
                            Company name
                            <input v-model="form.companyName" type="text" placeholder="" @input="$v.form.companyName.$touch">
                        </label>

                        <div v-if="$v.form.companyName.$error" class="messages">
                            <span v-if="!$v.form.companyName.required">Company name is required.</span>
                            <span v-if="!$v.form.companyName.minLength">Your company name must have at least 3 characters.</span>
                        </div>
                    </div>

                    <div v-if="getChannelSalesList" class="form-group">
                        <label class="full">Business Type</label>

                        <vSelect
                            label="description"
                            v-model="selectedSalesChannel"
                            :options="getChannelSalesList"
                            placeholder="Pick a sales channel ..."
                            @input="updateSalesChannel">
                        </vSelect>
                    </div>

                    <div class="form-group mt-4" >
                        <label class="full">
                            Website
                            <input v-model="form.website" type="text" placeholder="www.website.com">
                        </label>
                    </div>

                    <!-- <div class="form-group" v-if="sizes">
                        <label class="full">Team size</label>

                        <v-select
                            label="description"
                            v-model="selectedSize"
                            :options="sizes"
                            placeholder="How many sellers do you have?"
                            :searchable="false"
                            @input="updateSize">
                        </v-select>
                    </div> -->

                    <!-- <div class="form-group">
                        <label class="full mb-4">Your sales channels</label>

                        <label class="full mb-2">
                            <checkbox v-model="form.salesStore">
                                I'm selling in my own ticket store.
                            </checkbox>
                        </label>

                        <label class="full mb-2">
                            <checkbox v-model="form.salesWebsite">
                                I'm selling in my website.
                            </checkbox>
                        </label>

                        <label class="full mb-2">
                            <checkbox v-model="form.salesHotel">
                                I'm an hotel and I sell products to my customers.
                            </checkbox>
                        </label>
                    </div> -->

                    <div class="row">
                        <div class="col-md-6">
                            <router-link :to="{ name: 'auth.signup.agent' }">
                                <input type="button" class="btn tertiary widest full" value="Back">
                            </router-link>
                        </div>
                        <div class="col-md-6 text-center">
                            <button type="submit" class="btn blue widest full" value="Submit" :disabled="$v.$invalid || submittingRegistration">
                                <loader v-if="submittingRegistration"></loader>
                                <span v-else>Submit</span>
                            </button>
                        </div>
                    </div>

                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import loader from '@/tools/loaders/loader1'
    import { mapActions, mapGetters } from 'vuex'
    import AvatarUploader from '../../common/AvatarUploader'
    import extendedVSelect from '@/extends/vue-select'
    import { required, minLength } from 'vuelidate/lib/validators'

    export default {
        data: function() {
            return {
                step: 2,
                form: {
                    salesChannel: null,
                },
                selectedSize: null,
                submittingRegistration: false,
                selectedSalesChannel: null,
            }
        },
        validations: {
            form: {
                companyName: {
                    required,
                    minLength: minLength(3)
                }
            }
        },
        created: function() {
            // Redirect if we landed here without having passed through the needed steps

            if (this.accountSetup.type !== 'agent') {
                this.resetAccountSetup('agent');
                this.$router.push({ name: 'auth.signup' });
            } else {
                this.form = this.accountSetup;
                this.eventHub.$emit('sidebar', 'create');
                this.eventHub.$emit('topLink', 'login');

                // if(this.accountSetup.size){
                //     this.selectedSize = this.accountSetup.size
                // }


            }

            // set harcoded data
            this.$set(this.form, 'size', 10)
            this.$set(this.form, 'country', 176)
        },
        mounted: function() {
            // this.form.name = 'Pluralo Test';
            // this.form.salesStore = true;
            // this.form.salesWebsite = true;
            // this.form.salesHotel = true;
        },
        computed: {
            ...mapGetters([
                'accountSetup',
                'getChannelSalesList'
            ]),
        },
        asyncComputed: {
            // async sizes() {
            //     try {
            //         let response = await axios.get('/api/settings/GetAgentSizeList');
            //
            //         if (response && response.status === 200 && response.data && response.data.length > 0) {
            //
            //             if(this.form.size){
            //                 let selectedSize = response.data.filter(sizeOption => {
            //                     return sizeOption.id == this.accountSetup.size
            //                 })[0]
            //
            //                 this.selectedSize = selectedSize
            //             } else {
            //                 this.form.size = response.data[0];
            //             }
            //
            //             return response.data;
            //         }
            //     }
            //     catch (error) {
            //         this.$toasted.error(error.response.data.message);
            //     }
            // }
            // async salesChannels() {
            //     try {
            //         let response = await axios.get('/api/settings/GetChannelSalesList');
            //
            //         if (response && response.status === 200 && response.data && response.data.length > 0) {
            //             this.form.salesChannel = response.data[0];
            //             return response.data;
            //         }
            //     }
            //     catch (error) {
            //         this.$toasted.error(error.response.data.message);
            //     }
            // }
        },
        methods: {
            ...mapActions([
                'resetAccountSetup',
                'updateAccountSetup',
                'register'
            ]),
            processForm: function() {
                this.form.step = this.step + 1;

                // Update account setup data

                this.updateAccountSetup(this.form);

                // Move on to step 3

                this.$router.push({ name: 'auth.signup.agent.finish' });
            },
            processFormFinish: function() {
                if(!this.submittingRegistration){
                    // this.form.step = this.step + 1;

                    // Update account setup data

                    this.updateAccountSetup(this.form);

                    // Create an agent account via API
                    this.submittingRegistration = true
                    this.register(this.parseQueryString(this.accountSetup)).then(response => {
                        this.submittingRegistration = false
                        // Reset the setup object

                        this.resetAccountSetup('agent');

                    })

                } else {
                    this.$toasted.info('Already submitting your registration, please wait');
                }
            },
            addUploadedAvatar: function(avatar) {
                this.form.imageLogoBase64 = avatar;
            },
            updateSize: function() {
                this.form.size = this.selectedSize.id || null;
            },
            updateSalesChannel: function() {
                this.form.salesChannel = this.selectedSalesChannel.id || null;
            },
        },
        components: {
            vSelect: extendedVSelect,
            AvatarUploader,
            loader
        }
    }
</script>



// WEBPACK FOOTER //
// Step2.vue?6209df60